// extracted by mini-css-extract-plugin
export var avatar = "_qp-3";
export var avatarContainer = "_qp-2";
export var avatarSpacer = "_qp-5";
export var avatarSpacerContainer = "_qp-4";
export var avatarStackContainer = "_qp-1";
export var bubble = "_qp-0";
export var remainderBubble = "_qp-6";